import styles from './ActivityFeed.module.css';

// The concrete things the search just did, named.
//
// A status line can only ever say what stage we are in. This says what actually happened: which
// company was checked, who was found, who was dropped and why. It is the difference between
// "still working" - which the user has to take on faith - and visible evidence of work, and it
// costs nothing to produce because the server was already logging every one of these to a
// console the user never sees.
//
// Deliberately not `✓` bullets like the status lines above it. These are observations, not
// completed steps: "Ironclad looks like SaaS, not legaltech - skipping" is a thing that
// happened, not a milestone reached, and a green tick next to it would read as approval.
//
// Kept short on purpose. The feed is a window on the last few events, not a build log - it is
// capped before it reaches here, and cleared when the search finishes, so nothing persists a
// transcript of every company we looked at into the user's chat history forever.
export default function ActivityFeed({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <div className={styles.feed} aria-hidden="true">
      {items.map((item, i) => (
        <div
          key={`${i}-${item.text}`}
          className={`${styles.row} ${item.kind === 'contact_dropped' || item.kind === 'industry_mismatch' ? styles.skipped : ''}`}
          title={item.text}
        >
          <span className={styles.bullet}>·</span>
          <span className={styles.label}>{item.text}</span>
        </div>
      ))}
    </div>
  );
}
